import { render, staticRenderFns } from "./EditExtraModal.vue?vue&type=template&id=2dbe73b2&"
import script from "./EditExtraModal.vue?vue&type=script&lang=js&"
export * from "./EditExtraModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports